import { useState } from "react";
import { toast } from "sonner";
import { Wand2 } from "lucide-react";
import { api } from "@/lib/api";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AdminExtract() {
  const [text, setText] = useState("");
  const [urls, setUrls] = useState("");
  const [sourceUrl, setSourceUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setLoading(true); setResult(null);
    try {
      const image_urls = urls.split(/\s|,|\n/).map(s=>s.trim()).filter(Boolean);
      const r = await api.post("/admin/extract", { text, image_urls, source_url: sourceUrl || null });
      setResult(r.data);
      toast.success(`Extracted ${r.data.total_extracted} · added ${r.data.created.length} pending · deduped ${r.data.deduped}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Extraction failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-2xl font-bold tracking-tight text-[#1A3C5A] mb-1">AI extract</h1>
      <p className="text-sm text-slate-600 mb-4">Paste raw text (from a post, email, flyer OCR), optionally with flyer image URLs. Claude Sonnet 4.5 will structure it and drop events into the review queue.</p>

      <div className="space-y-3 bg-white border border-border rounded-md p-4">
        <div className="space-y-1"><Label>Raw text</Label>
          <Textarea rows={8} value={text} onChange={(e)=>setText(e.target.value)} placeholder="Paste a post caption, email body, or website copy…" data-testid="extract-text"/>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1"><Label>Image URLs (comma or newline separated)</Label>
            <Textarea rows={3} value={urls} onChange={(e)=>setUrls(e.target.value)} className="font-mono text-xs" data-testid="extract-urls"/>
          </div>
          <div className="space-y-1"><Label>Source URL (optional)</Label>
            <Input value={sourceUrl} onChange={(e)=>setSourceUrl(e.target.value)} placeholder="https://…" data-testid="extract-source-url"/>
          </div>
        </div>
        <Button onClick={run} disabled={loading || !text} className="bg-[#1A3C5A] text-white hover:bg-[#12293e]" data-testid="extract-run">
          <Wand2 size={14} className="mr-1"/>{loading ? "Extracting…" : "Extract with Claude 4.5"}
        </Button>
      </div>

      {result && (
        <div className="mt-4 bg-white border border-border rounded-md p-4">
          <div className="font-display font-semibold mb-2">Result</div>
          <div className="text-sm text-slate-600 mb-3">
            {result.total_extracted} extracted · {result.created.length} added as pending · {result.deduped} deduped
          </div>
          <ul className="text-sm space-y-1">
            {result.created.map((e) => (
              <li key={e.id} className="border-b border-border py-1">
                <span className="font-medium">{e.title}</span>
                <span className="text-slate-500"> · {e.start_datetime}</span>
                {e.town && <span className="text-slate-500"> · {e.town}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
